import gql from 'graphql-tag'
import { graphql, ChildDataProps } from 'react-apollo'
import { RouteComponentProps } from 'react-router-dom'
import { CalcProjectStore } from 'redux/reducers/calcProject'

import isNil from 'lodash/isNil'

import { getProjectId } from 'utils'

export interface InputProps extends RouteComponentProps<any> {
  authenticated: boolean
  calcProject: CalcProjectStore
}

export type Variables = {
  version: string
  projNr: string
  eleId: number
}

export type Response = {}

type ChildProps = ChildDataProps<InputProps, Response, Variables>

export const POSITION_DATA_QUERY = gql`
  query getPosition($version: String!, $projNr: String!, $eleId: Float!) {
    getPosition(version: $version, projNr: $projNr, eleId: $eleId) {
      id
      mainId
      number
      name
      amount
      unit
      filters {
        name
        shortName
        unit
        id
        values
        selectedValue
        condition
      }
      materialCosts {
        materials {
          id: recId
          recId
          articleNumber
          producer
          product
          amount
          unit
          amountWithClipping
          clippingPercentage
          unitPrice
          totalPrice
          condition
        }
        totalPrice
      }
      timeCosts {
        activities {
          id: recId
          recId
          articleNumber: id
          product: activity
          amount
          unitPrice
          totalPrice
        }
        totalTime
        totalPrice
      }
      unitPrice
      totalPrice
      graphic
      annotation
      hourlyRate
      vat
      totalPriceBrutto
    }
  }
`

const isProjectCalculation = (props: InputProps) => {
  const { calculationId } = props.match.params
  const projectId = getProjectId(props)

  return !isNil(projectId) && !isNil(calculationId)
}

const withPositionDataQuery = graphql<InputProps, Response, Variables, ChildProps>(
  POSITION_DATA_QUERY,
  {
    name: 'positionData',
    /*
     * projectNumber is not fetched yet
     * Do not execute the query
     */
    skip: (props: InputProps) => !props.calcProject.projectNumber,
    options: (props: InputProps) => {
      const { projectNumber } = props.calcProject
      const projectId: any = getProjectId(props)
      const calculationId: string = props.match.params.calculationId

      if (isProjectCalculation(props)) {
        return {
          variables: {
            version: 'v1',
            projNr: projectId,
            eleId: Number(props.match.params.calculationId),
          },
          notifyOnNetworkStatusChange: true,
          fetchPolicy: 'network-only',
        }
      } else if (!isNil(calculationId)) {
        // It is a fast calculation / default calculation project
        return {
          variables: {
            version: calculationId,
            projNr: projectNumber,
            eleId: 1,
          },
          notifyOnNetworkStatusChange: true,
          fetchPolicy: 'network-only',
        }
      }

      return {}
    },
  },
)

export default withPositionDataQuery
